/**
 * Restrict the model dropdown to the models this deployment actually serves.
 *
 * pi-web-ui's ModelSelector lists its whole built-in catalog (Anthropic,
 * OpenAI, Google, …) — none of which work here, since the only upstreams are
 * the Spark's vLLM and (per-user) Scaleway. We patch getFilteredModels — an
 * ordinary prototype method Lit calls dynamically (NOT a lifecycle callback,
 * which customElements.define freezes at registration) — to return only the
 * backend-approved list from /api/models.
 */

import { ModelSelector } from "@earendil-works/pi-web-ui";
import { getAllowedModels } from "../llm/models.js";

type SelectorEntry = { provider: string; id: string; model: unknown };

const proto = ModelSelector.prototype as unknown as {
	searchQuery?: string;
	getFilteredModels(): SelectorEntry[];
	handleSelect(model: unknown): void;
};

proto.getFilteredModels = function (): SelectorEntry[] {
	const q = (this.searchQuery ?? "").toLowerCase().trim();
	return getAllowedModels()
		.filter((m) => !q || `${m.id} ${m.name}`.toLowerCase().includes(q))
		.map((m) => ({ provider: m.provider, id: m.id, model: m }));
};

// AgentInterface's select callback assigns session.state.model directly,
// which doesn't trigger a Lit re-render — the model chip in the editor kept
// showing the old model until the next agent event. Nudge the interfaces
// after a selection so the chip updates immediately.
const origHandleSelect = proto.handleSelect;
proto.handleSelect = function (model: unknown) {
	origHandleSelect.call(this, model);
	for (const ai of document.querySelectorAll("agent-interface")) {
		(ai as { requestUpdate?: () => void }).requestUpdate?.();
	}
};
